module.exports = __webpack_public_path__ + "img/box-zuklappen-weiss.4478fbb2.svg";